import { useData } from "@hooks/useData";
import Http from "@core/fetch";

export interface iChainMenuCountDto {
    chainId: number;
    menuItemCount: number | null;
}

async function getChainsByMenu(includes: string[], excludes: string[]): Promise<iChainMenuCountDto[]> {
    if (!includes.length && !excludes.length) return [];
    return Http.get('filter chains by menu', { includes, excludes });
}

export default function useChainsMenuFilter(includes: string[], excludes: string[]) {
    return useData<iChainMenuCountDto[]>([], getChainsByMenu, includes, excludes);
}
